import { useId, useState } from 'react';
import AsyncButton from '@wojtekmaj/react-async-button';
import T from '@wojtekmaj/react-t';
import { ThumbsDownIcon, ThumbsUpIcon } from 'lucide-react';

import colors from '@rewardopl/styles/colors';

import Button from '@rewardopl/react-ui/button';
import Dialog from '@rewardopl/react-ui/dialog';
import TextareaField from '@rewardopl/react-ui/textarea_field';

import { post } from '@rewardopl/utils/network';

import {
  Description,
  Form,
  Image,
  Input,
  Label,
  Question,
  Text,
  ThumbsWrapper,
  Wrapper,
} from './dialog.styles';

import popperIcon from '../../../../static/popper.svg';

import type { Transaction } from '@rewardopl/types';

const pendingConfig = {
  disabled: true,
};

type TransactionsMonitorDialogProps = {
  onDismiss: () => void;
  transaction: Transaction;
};

export default function TransactionsMonitorDialog({
  onDismiss,
  transaction,
}: TransactionsMonitorDialogProps) {
  const badId = useId();
  const goodId = useId();
  const [rating, setRating] = useState<number>();

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    setRating(Number(event.target.value));
  }

  const action = '/api/feedback';

  async function onClick(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    event.preventDefault();

    const submitButton = event.currentTarget;
    const form = submitButton.form;

    if (!form || !form.reportValidity()) {
      return;
    }

    await post(action, {
      body: new FormData(form),
    });

    onDismiss();
  }

  return (
    <Dialog isOpen onDismiss={onDismiss} title="Awesome!">
      <Wrapper>
        <Image alt="" height="256" src={popperIcon} width="256" />
        <Description>
          <T amount={transaction.amount}>{`You have earned {amount} point${
            transaction.amount === 1 ? '' : 's'
          }!`}</T>
        </Description>
        <Question>
          <T>How was your experience?</T>
        </Question>
        <Form action={action} method="POST">
          <input
            name="card_subscription_id"
            type="hidden"
            value={transaction.card_subscription_id}
          />
          <input name="transaction_id" type="hidden" value={transaction._id} />
          <ThumbsWrapper>
            <Input id={badId} name="rating" onChange={onChange} type="radio" value="0" />
            <Label htmlFor={badId}>
              <Text>Bad</Text>
              <ThumbsDownIcon
                fill={rating === 0 ? colors['error-background'] : 'transparent'}
                size={64}
                stroke={colors['error-dark']}
                strokeWidth={1}
              />
            </Label>
            <Input id={goodId} name="rating" onChange={onChange} type="radio" value="100" />
            <Label htmlFor={goodId}>
              <Text>Good</Text>
              <ThumbsUpIcon
                fill={rating === 100 ? colors['success-background'] : 'transparent'}
                size={64}
                stroke={colors['success-dark']}
                strokeWidth={1}
              />
            </Label>
          </ThumbsWrapper>
          {rating === 0 ? (
            <TextareaField label="Please tell us how we can improve." name="comment" />
          ) : null}
          {rating !== undefined ? (
            <AsyncButton
              as={Button}
              className="primary"
              onClick={onClick}
              pendingConfig={pendingConfig}
              type="submit"
            >
              <T>Submit</T>
            </AsyncButton>
          ) : null}
        </Form>
      </Wrapper>
    </Dialog>
  );
}
